export enum Ability {
  // Misc
  HighLevelDataAccess = 'high_level_data_access',
  // Candidates
  ViewCandidates = 'view_candidates_section',
  ManageCandidates = 'manage_candidate',
  DeleteCandidates = 'delete_candidates',
  ShareCandidates = 'share_candidates',
  ReviewHiddenEvaluations = 'review_hidden_evaluations',
  RevealAnonymousCandidates = 'reveal_anonymous_candidates',
  // Hires
  ViewHiredCandidates = 'view_hired_candidates',
  ManageHiredCandidates = 'manage_hired_candidates',
  // Jobs
  ViewJobs = 'view_jobs_section',
  ViewAllJobs = 'view_all_jobs',
  ManageJobs = 'manage_jobs',
  ManageAutomatedActions = 'manage_automated_actions',
  AssignUsersToJobs = 'assign_users_to_jobs',
  PublishJobs = 'publish_jobs',
  ManageJobsReferralSettings = 'manage_jobs_referral_settings',
  // Workflow
  ManageCustomFields = 'manage_dynamic_fields',
  AssignCustomFields = 'assign_dynamic_fields',
  ManageTemplates = 'manage_templates',
  ManageDisqualifyReasons = 'manage_disqualify_reasons',
  ManageAttributes = 'manage_attributes',
  ManageProfileFields = 'manage_profile_fields',
  ManageOpenQuestions = 'manage_open_questions',
  ManageReferralTemplates = 'manage_referral_templates',
  ExportData = 'export_data',
  // Mailbox
  ViewMailbox = 'view_mailbox_section',
  SendEmails = 'send_emails',
  ManageEmailIntegrations = 'manage_email_integrations',
  // Calendar
  ViewCalendar = 'view_calendar_section',
  ScheduleEvents = 'schedule_events',
  // Promote
  ViewAcquisition = 'view_promote_section',
  FreeJobsBoards = 'free_job_boards',
  PremiumJobBoards = 'premium_job_boards',
  ManageJobBoardsCredentials = 'manage_job_boards_credentials',
  // Report Dashboards
  ManageReportDashboards = 'manage_report_dashboards',
  // Offer Letters
  ManageOfferLetters = 'manage_offer_letters',
  // Company
  ManageCompany = 'manage_company',
  ManageSubscription = 'manage_subscription',
  ManageRecruiters = 'manage_recruiters',
  ManageGdpr = 'gdpr',
  ManageReferrals = 'manage_referrals',
  // Add-ons
  ManageIntegrations = 'manage_integrations',
  EditCareersSite = 'edit_career_site',
  ManageJobWidget = 'manage_job_widget',
  ManageApiTokens = 'manage_api_tokens',
  ManageWebhooks = 'manage_webhooks',
  // Templates
  ManagePipelineTemplates = 'manage_pipeline_templates',
  ManageProfileFieldsTemplates = 'manage_profile_fields_templates',
  ManageEmailTemplates = 'manage_email_templates',
  ManageInterviewTemplates = 'manage_interview_templates',
  ManageOpenQuestionTemplates = 'manage_open_questions_templates',
  ManageJobTemplates = 'manage_job_templates',
  // Requisition approvals
  ViewRequisitions = 'view_requisitions',
  ViewAllRequisitions = 'view_all_requisitions',
  ManageRequisitions = 'manage_requisitions',
  ManageTexting = 'manage_texting',
  ViewSms = 'view_sms',
  SendSms = 'send_sms',
  // Locations
  ManageLocations = 'manage_locations',
}
